import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_AppScopes4bqeg21n0qw as get_AppScope } from '../../../../reactive/com/lightningkite/reactive/core/AppScope.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { get_pwaInstallAvailable261a64jtq77ae as get_pwaInstallAvailable } from '../views/components/nav/crowpay.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { initMetadataForLambda3af3he42mmnh as initMetadataForLambda } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var prompt;
function pwaInstallAvailabilityCheck() {
  var tmp = window;
  tmp.addEventListener('beforeinstallprompt', pwaInstallAvailabilityCheck$lambda);
  var tmp_0 = window;
  tmp_0.addEventListener('appinstalled', pwaInstallAvailabilityCheck$lambda_0);
}
function pwaInstallPrompt() {
  var tmp0_safe_receiver = prompt;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.js.asDynamic' call
    tmp = tmp0_safe_receiver;
  }
  tmp.prompt();
}
function pwaInstallAvailabilityCheck$lambda(event) {
  event.preventDefault();
  prompt = event;
  var tmp = get_AppScope();
  launch(tmp, VOID, VOID, pwaInstallAvailabilityCheck$lambda$slambda_0());
  return Unit_instance;
}
function *_generator_invoke__zhh2q8($this, $this$launch, $completion) {
  var tmp = get_pwaInstallAvailable().iah(true, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var pwaInstallAvailabilityCheck$lambda$slambdaClass;
function pwaInstallAvailabilityCheck$lambda$slambda() {
  if (pwaInstallAvailabilityCheck$lambda$slambdaClass === VOID) {
    class $ {
      yah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    pwaInstallAvailabilityCheck$lambda$slambdaClass = $;
  }
  return pwaInstallAvailabilityCheck$lambda$slambdaClass;
}
function pwaInstallAvailabilityCheck$lambda$slambda_0() {
  var i = new (pwaInstallAvailabilityCheck$lambda$slambda())();
  var l = ($this$launch, $completion) => i.yah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
function pwaInstallAvailabilityCheck$lambda_0(event) {
  var tmp = get_AppScope();
  launch(tmp, VOID, VOID, pwaInstallAvailabilityCheck$lambda$slambda_2());
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, $this$launch, $completion) {
  var tmp = get_pwaInstallAvailable().iah(false, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var pwaInstallAvailabilityCheck$lambda$slambdaClass_0;
function pwaInstallAvailabilityCheck$lambda$slambda_1() {
  if (pwaInstallAvailabilityCheck$lambda$slambdaClass_0 === VOID) {
    class $ {
      yah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    pwaInstallAvailabilityCheck$lambda$slambdaClass_0 = $;
  }
  return pwaInstallAvailabilityCheck$lambda$slambdaClass_0;
}
function pwaInstallAvailabilityCheck$lambda$slambda_2() {
  var i = new (pwaInstallAvailabilityCheck$lambda$slambda_1())();
  var l = ($this$launch, $completion) => i.yah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
//region block: init
prompt = null;
//endregion
//region block: exports
export {
  pwaInstallAvailabilityCheck as pwaInstallAvailabilityCheck1bnae6eqkhryw,
  pwaInstallPrompt as pwaInstallPrompt2aaai8ml9vmh3,
};
//endregion

//# sourceMappingURL=pwaCheck.js.mjs.map
